import { useState } from 'react'

import styles from './Header.module.scss'
import NavItem from './NavItem'

import { navigationList } from 'resources'
import { useLockBodyScroll, useVersion } from 'hooks'
import { ReactComponent as AwsLogo } from 'assets/svg/logo.svg'

// interface HeaderProps {
//   isEdition?: boolean
// }

const Header = () => {
  const { version } = useVersion()

  const [isOpened, setIsOpened] = useState(false)

  useLockBodyScroll(isOpened)

  const navigationData = navigationList[version as keyof typeof navigationList]

  const renderNavigationList = navigationData.map(({ id, title, Icon, isLink, link, mainNavigation }: any, index) => (
    <NavItem
      key={id}
      title={title}
      Icon={Icon}
      isLink={isLink}
      link={link}
      index={index}
      setIsOpened={setIsOpened}
      mainNavigation={mainNavigation}
    />
  ))

  return (
    <header className={styles.wrapper}>
      <nav className={`${styles.wrapper__nav} ${isOpened ? styles.wrapper__nav__active : ''}`}>
        {renderNavigationList}
      </nav>

      <div className={styles.wrapper__nav_mobile}>
        <p className={styles.toogle} onClick={() => setIsOpened(!isOpened)}>
          <span />
        </p>
        <AwsLogo onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} />
      </div>
    </header>
  )
}

export default Header
